<template>
  <div v-if="website.id">
    <form v-if="website" action="/" class="ba-w-100 ba-grid ba-gp-08">
      <div class="ba-flex ba-f-wrap ba-gp-08">
        <div class="ba-box-input ba-w-100">
          <label for="name" class="ba-custom-label" v-text="$t('ct-title')" />
          <input id="name" v-model="website.title" :class="{ 'ba-error': errors.has('website.title') }" class="ba-input ba-md"
            required="required" type="text" @keydown="errors.clear('website.title')" />
          <span v-if="errors.has('website.title')" class="ba-validation-text"
            v-text="errors.get('website.title')"></span>
        </div>
        <div class="ba-box-input ba-w-100">
          <label for="url" class="ba-custom-label" v-text="$t('ct-address-url')" />
          <input id="url" v-model="website.url" :class="{ 'ba-error': errors.has('website.url') }" class="ba-input ba-md"
            required="required" type="text" @keydown="errors.clear('website.url')" @keyup="validateURL" />
          <span v-if="errors.has('website.url')" class="ba-validation-text" v-text="errors.get('website.url')"></span>
        </div>

        <div class="ba-w-100 ba-flex ba-f-nowrap ba-gp-08">
          <div class="ba-grid ba-w-100">
            <label for="title-separator" class="ba-custom-label" v-text="$t('ct-title-separator')" />
            <select id="title-separator" v-model="website.configuration.title_separator" class="ba-select ba-md"
              name="title_separator">
              <option value="|">|</option>
              <option value="~">~</option>
              <option value="-">-</option>
            </select>
          </div>

          <div class="ba-grid ba-w-100">
            <label for="title-separator" class="ba-custom-label" v-text="$t('ct-tablet-version')" />
            <select id="title-separator" v-model="website.tablet_version" class="ba-select ba-md" name="title_separator">
              <!-- <option value=" ">Empty</option> -->
              <option value="1">{{ 'Tablet' }}</option>
              <option value="0">{{ 'Desktop' }}</option>
            </select>
          </div>

          <div v-if="this.$store.getters.getLanguages" class="ba-grid ba-w-100">
            <label for="language" class="ba-custom-label" v-text="$t('ct-language')" />
            <select id="language" v-model="website.language" class="ba-select ba-md" name="language">
              <option v-for="(language, index) in this.$store.getters.getLanguages" :key="index"
                :value="language.descricao">{{ language.label_desc ? language.label_desc : language.descricao }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="website.dominio" class="ba-box-input">
          <label for="dominio" class="ba-custom-label" v-text="$t('ct-domain')" />
          <input id="dominio" v-model="website.dominio" :class="{ 'ba-error': errors.has('website.dominio') }"
            class="ba-input ba-md" disabled type="text" />
          <span v-if="errors.has('website.dominio')" class="ba-validation-text"
            v-text="errors.get('website.dominio')" />
        </div>

        <div class="ba-box-input d-none">
          <label for="website-type" class="ba-custom-label">{{ $t('ct-website-type') }}</label>
          <select id="website-type" v-model="website.type" :class="{ 'ba-error': errors.has('website.type') }"
            class="ba-input ba-md" name="website-type">
            <option disabled selected value="">{{ $t('ct-website-type') }}</option>
            <option value="website">{{ $t('ct-website-type-website') }}</option>
            <option value="template">{{ $t('ct-website-type-template') }}</option>
          </select>
          <span v-if="errors.has('website.type')" class="ba-validation-text" v-text="errors.get('website.type')"></span>
        </div>

        <div class="form-group pr-4 col-xs-12 col-sm-5 col-md-2 d-none">
          <label for="template-flag">{{ $t('ct-template-flag') }}</label>
          <select id="template-flag" v-model="website.template_flag"
            :class="{ 'is-invalid': errors.has('website.template_flag') }" class="form-control" name="template-flag">
            <option disabled selected value="">{{ $t('ct-template-flag') }}</option>
            <option value="website">{{ $t('ct-template-flag-website') }}</option>
            <option value="landing_page">{{ $t('ct-template-flag-landing-page') }}</option>
            <option value="personal_branding">{{ $t('ct-template-flag-personal-branding') }}</option>
          </select>
          <span v-if="errors.has('website.template_flag')" class="invalid-feedback"
            v-text="errors.get('website.template_flag')"></span>
        </div>

        <div class="ba-grid ba-w-100">
          <label for="description" class="ba-custom-label" v-text="$t('ct-description')" />
          <textarea id="description" v-model="website.configuration.description" class="ba-textarea" cols="30" rows="5"
            name="description" />
        </div>

        <div v-if="categories.length > 0 && website.categories" class="ba-grid">
          <label class="ba-custom-label" for="categories">{{ $t('ct-categories') }}</label>
          <v-select v-model="website.categories" :dir="this.$translate.getDir() ? this.$translate.getDir() : ''"
            :options="categories" :reduce="category => category.id" label="name" multiple class="ba-select">
            <template slot="option" slot-scope="option">{{ option.name }}</template>
          </v-select>
        </div>

        <div v-if="emails_themes && emails_themes.length > 0" class="ba-grid">
          <label for="email-members-theme" class="ba-custom-label">{{ $t('ct-email-members-theme') }}</label>
          <select id="email-members-theme" v-model="website.automatic_email_id" class="ba-select"
            name="email-members-theme">
            <option :value="null">{{ $t('ct-default') }}</option>
            <option v-for="(theme, index) in emails_themes" :key="index" :value="theme.id">{{ theme.name }}
            </option>
          </select>
        </div>

        <div class="ba-grid ba-w-50">
          <label for="panel-list-mb" class="ba-custom-label">{{ $t('ct-mailing-boss-list-panels') }}</label>
          <div v-if="loading_mailingboss" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <select v-else id="panel-list-mb" v-model="website.configuration.list_uid_panels" class="ba-select ba-md"
            name="panel-list-mb">
            <option :value="null">{{ $t('ct-mailing-boss-list-select') }}</option>
            <option v-for="(mb_list, index) in mailingboss_lists" :key="index" :value="mb_list.general.list_uid">{{
              mb_list.general.name }}
            </option>
          </select>
        </div>

        <div v-if="!userCurrent.user_domain" class="ba-grid ba-w-100">
          <div class="ba-w-100 ba-flex ba-ai-center ba-gp-06">
            <label class='ba-switch ba-sm'>
                <input type='checkbox' class='ba-checkbox' v-model="website.configuration.watermark">
                <span class='ba-slider'></span>
            </label>
            <label for="watermark" v-text="$t('ct-watermark')" />
          </div>
          <div v-show="website.configuration.watermark" class="ba-w-100 ba-flex ba-gp-08">
            <div class="ba-grid ba-w-50">
              <label class="ba-custom-label" v-text="$t('ct-lang-of-watermark')" />
              <select v-model="website.configuration.watermark_lang" class="ba-select ba-md">
                <option disabled selected value>{{ $t('ct-choose-language') }}</option>
                <option v-for="(lang, index) in this.$store.getters.getLanguages" :key="index"
                  :selected="website.configuration.watermark_lang === lang.descricao ? 'selected' : false"
                  :value="lang.descricao">{{ lang.label_desc }}
                </option>
              </select>
            </div>
            <div class="ba-grid ba-w-50">
              <label class="ba-custom-label" v-text="$t('ct-side-of-watermark')" />
              <select v-model="website.configuration.watermark_side" class="ba-select ba-md">
                <option value="left">{{ $t('ct-left') }}</option>
                <option value="center">{{ $t('ct-center') }}</option>
                <option value="right">{{ $t('ct-right') }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="ba-w-100 ba-ai-center ba-flex ba-gp-06">
          <label class='ba-switch ba-sm'>
              <input type='checkbox' class='ba-checkbox' v-model="website.configuration.crm_enable">
              <span class='ba-slider'></span>
          </label>
          <label for="crm-enable" v-text="$t('ct-crm-enable')" />
        </div>

        <div class="ba-w-100">
          <div class="favicon-container">
            <label class="ba-custom-label">Favicon</label>
            <div class="favicon-options">
              <div v-if="website.layout.configuration.favicon" class="ba-flex ba-ai-center ba-gp-08">
                <div class="favicon-preview">
                  <div :style="`background-image: url('${website.layout.configuration.favicon}');`"
                    class="favicon-image" />
                </div>
                <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click.prevent="getImages">
                  <builderall-icon code='edit' />
                </button>
                <button @click.prevent="removeImage" class='ba-btn ba-btn-trash ba-sm ba-rounded'>
                  <builderall-icon code='trash' />
                </button>
              </div>
              <div v-else class="ba-w-50 ba-bg-light14 ba-pd-y-1 ba-flex ba-ai-center ba-jc-center"
                style="height: 40px; width: 277px; border-radius: 6px; cursor: pointer"
                @click.prevent="getImages">
                <builderall-icon code='9da0'></builderall-icon>
              </div>
            </div>
          </div>
        </div>

        <div class="ba-box-input ba-w-100">
          <label class="ba-custom-label" :for="'redirect-to'">{{ $t('ct-website-redirect-to') }}</label>
          <input id="redirect-to" v-model="website.configuration.redirect_to"
            :class="{ 'ba-error': errors.has('website.redirect_to') }" class="ba-input ba-md" name="redirect-to"
            pattern="https://.*" type="url" @keyup="validateRedirectTo" />
          <span v-if="errors.has('website.redirect_to')" class="ba-validation-text" v-text="errorRedirectTo"></span>
          <small class="ba-color-black18">{{ $t('ct-website-redirect-to-helper') }}</small>
        </div>

      </div>
      <!-- Site Settings -->
      <div
        :class="{ 'd-none': website.layout.script && (!website.layout.script.script_pixel && !website.layout.script.script_analytics) }">
        <div class="card">
          <div class="card-header border-0 d-flex align-items-center justify-content-between">
            {{ $t('ct-script-analytics') }}
            <div class="for-group">
              <button class="cheetah-button cheetah-button-size-small cheetah-button-color-success" type="button"
                @click.prevent="saveSettings(website)">
                <i class="svg-icon svgi-save" />
                {{ $t('ct-save') }}
              </button>
            </div>
          </div>
          <div class="card-body">
            <ace-code-editor :content="website.layout.script.script_analytics" config="script_analytics"
              editorId="script-pixel-analytics" @change-content="changeScript"></ace-code-editor>

            <div class="form-group">
              <div class="ba-w-100 ba-flex ba-ai-center ba-gp-06">
                <label class='ba-switch ba-sm' @click="website.layout.script.script_analytics_sync = !website.layout.script.script_analytics_sync">
                    <input type='checkbox' class='ba-checkbox' v-model="website.layout.script.script_analytics_sync">
                    <span class='ba-slider'></span>
                </label>

                <label v-text="$t('ct-enable-synchronous-script')" />
              </div>

              <alert-box-component :with_icon="true" type="warning">
                <p slot="content" v-text="$t('ct-sync-script')" />
              </alert-box-component>

            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header border-0 d-flex align-items-center justify-content-between">
            {{ $t('ct-script-pixel') }}
            <div class="for-group">
              <button class="cheetah-button cheetah-button-size-small cheetah-button-color-success" type="button"
                @click.prevent="saveSettings(website)">
                <i class="svg-icon svgi-save" />
                {{ $t('ct-save') }}
              </button>
            </div>
          </div>
          <div class="card-body">
            <ace-code-editor :content="website.layout.script.script_pixel" config="script_pixel" editorId="script-pixel"
              @change-content="changeScript"></ace-code-editor>

            <div class="form-group">
              <div class="ba-w-100 ba-flex ba-ai-center ba-gp-06">
                <label class='ba-switch ba-sm' @click="website.layout.script.script_pixel_sync = !website.layout.script.script_pixel_sync">
                    <input type='checkbox' class='ba-checkbox' v-model="website.layout.script.script_pixel_sync">
                    <span class='ba-slider'></span>
                </label>

                <label v-text="$t('ct-enable-synchronous-script')" />
              </div>
              <alert-box-component :with_icon="true" type="warning">
                <p slot="content" v-text="$t('ct-sync-script')" />
              </alert-box-component>
            </div>
          </div>
        </div>
      </div>
      <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
        <button class="ba-btn ba-md ba-blue" type="button"
          @click.prevent="saveSettings(website)">
          {{ $t('ct-save') }}
        </button>
      </div>
    </form>
    <modal-saved-and-publish ref="success" :id_website="website.encrypted_id"></modal-saved-and-publish>
  </div>
</template>

<script>
import NavComponent from '../layout/nav/Nav';
import SiteSidebarComponent from '../layout/site/SiteSidebar';

import {edit as editWebsite, exclude as excludeWebsite} from '../../../js/services/editor/website';
import {getCategories} from '../../../js/services/category';
import Errors from '../../../js/base/Errors';
import {getAll as getAutomaticEmails} from './../../../js/services/restrictArea/automaticEmails';

import AlertBoxComponent from '../../commons/AlertBoxComponent';
import ToggleButtonComponent from '../../commons/ToggleButtonComponent';
import AceCodeEditor from "../components/AceCodeEditor";
import {getLists} from "../../../js/services/integrations-internas/mailingboss";
import ModalSavedAndPublish from "../../commons/ModalSavedAndPublish.vue";

export default {
  name: 'SiteSettings',
  components: {
    ModalSavedAndPublish,
    NavComponent,
    SiteSidebarComponent,
    AlertBoxComponent,
    ToggleButtonComponent,
    AceCodeEditor
  },
  data() {
    return {
      errors: new Errors(),
      changedRedirectTo: false,
      loading_mailingboss: false,
      mailingboss_lists: [],
      image: {
        show: false,
        layout: null
      },
      website: {
        layouts: []
      },
      categories: {},
      languages: {},
      emails_themes: {},
      configuration: {
        description: '',
        image: '',
        tab_color: '',
        redirect_to: '',
        title_separator: '|',
        title_order: 0,
        crm_enable: 0,
        watermark: 0,
        watermark_side: 'right',
        watermark_lang: 'en',
        list_uid_panels: null,
      },
      scriptLayout: {
        script: '',
        script_pixel: '',
        script_analytics: ''
      },
      menuNavBar: [
        {
          text: 'Meus Sites',
          link: 'Home',
          router: true,
          active: false,
          target: false,
          current: false
        }
      ]
    };
  },

  computed: {
    websiteCurrent() {
      return this.$store.getters.website;
    },
    userCurrent() {
      return this.$store.getters.user;
    },
    errorRedirectTo () {
      const error = this.errors.get('website.redirect_to')
      return error.includes('ct') ? this.errors.getTranslate(error) : error
    },
  },

  watch: {
    'websiteCurrent': {
      handler: function (val, oldVal) {
        this.setWebsite(val);
      },
      deep: true
    },
    'website.configuration.redirect_to': function (val, oldVal) {
      if (val) {
        if (val !== oldVal) {
          this.changedRedirectTo = true
        }
      }
    }
  },

  methods: {

    setWebsite(website) {

      if (!Object.keys(website).length)
        return;

      this.website = JSON.parse(JSON.stringify(website));

      this.website.layout = this.website.layouts[0];

      if (this.website.configuration === null) {
        this.website.configuration = this.configuration
      }

      if (this.website.layout.script === null) {
        this.website.layout.script = this.scriptLayout
      }

      if (this.website.layout.configuration === null) {
        this.website.layout.configuration = {
          favicon: '',
          keyword: '',
          metatag: ''
        };
      }
    },

    validateURL() {
      if (this.website.url && !this.website.url.match(/^[a-zA-Z0-9-]*$/)) {
        this.errors.add('url', 'invalid-url-regex', 'website');
      }

      if (this.website.url.match(/^[a-zA-Z0-9-]*$/)) {
        this.website.url = this.website.url.match(/^[a-zA-Z0-9-]*$/).input;
        if (this.errors.any()) this.website.clear('page.url');
      }
    },

    validateRedirectTo() {
      const isValidUrl = urlString => {
        var urlPattern = new RegExp('^(https:\\/\\/)' + // validate protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
          '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
        return !!urlPattern.test(urlString);
      }

      if (this.website.configuration.redirect_to && !isValidUrl(this.website.configuration.redirect_to)) {
        this.errors.add('redirect_to', 'invalid-redirect-to-regex', 'website');
      } else {
        if (this.errors.any()) this.errors.clear('website.redirect_to');
      }
    },

    changeScriptSync(config, value) {
      this[config] = value;
    },

    changeScript(value, config) {
      this.website.layout.script[config] = value;
    },

    clearCategories(categories) {
      if (typeof categories === 'object') {
        return Object.keys(categories).map(index => {
          if (typeof categories[index] === 'number') {
            return categories[index];
          } else return categories[index].id;
        });
      }
      return categories;
    },

    saveSettings(website) {
      this.$loading.show();

      this.website.categories = this.clearCategories(website.categories);
      this.website.layouts[0] = this.website.layout;

      let encryptedID = this.website.encrypted_id;

      if (!this.errors.any()) {
        editWebsite(website)
          .then(data => {
            if (data.data.error && !data.data.success) {
              this.errors.record(data.data.error);
              this.$snotify.error('Error save settings website');
            } else {
              this.$store.commit('website', website);
              this.$loading.hide();

              if (this.changedRedirectTo) {
                this.$refs.success.open();
                return;
              }
              this.$snotify.success(this.$t('ct-success-true'));

              this.$nextTick(() => {
                this.$router.push({
                  name: 'SitePages',
                  params: {id: encryptedID}
                });
              });
            }
          })
          .catch(response => {
            if (response.response) {
              this.errors.record({website: response.response.data.errors})
            }

            console.warn(response);
            this.$loading.hide();
          });
      } else {
        this.$loading.hide();
      }
    },

    getImages() {
      this.image.show = true;

      let values = {
        action: 'open',
        type: 'Images',
        save: this.saveImage,
        close: this.closeImage
      };

      this.$root.$emit('fileMananger', values);
    },

    closeImage() {
      let values = {
        action: 'close',
        type: 'Images',
        save: this.saveImage,
        close: this.closeImage
      };

      this.$root.$emit('fileMananger', values);
      
      this.image = {
        show: false,
        page: null
      };
    },

    saveImage(image) {
      if (image) {
        this.website.layout.configuration.favicon = image;

        this.canRemove = true;

        this.closeImage();
      }
    },

    removeImage() {
      this.website.layout.configuration.favicon = '';
    },

    deleteWebsite(website) {
      excludeWebsite(website)
        .then(data => {
          console.log('WEBSITE - DELETE: ', data);
        })
        .catch(error => console.warn(error));
    },

    fetchMailingbossList() {
      this.loading_mailingboss = true;

      getLists()
        .then(({data}) => {
          if (data.success) {
            this.mailingboss_lists = data.data;
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => this.loading_mailingboss = false);
    },
  },

  async created() {

    this.setWebsite(this.$store.getters.website);

    this.$loading.show();
    var self = this;

    this.fetchMailingbossList();

    await Promise.all([
      getCategories(),
      getAutomaticEmails(this.$route.params.id)
    ])
      .then(([categories, automaticEmails]) => {
        self.categories = categories.data;
        self.emails_themes = automaticEmails.data.data;
      })
      .catch(error => {
        console.warn(error);
      })
      .finally(() => {
        this.$loading.hide();
        window.vm.$Progress.finish();
      });

  }
};
</script>

<style lang="scss" scoped>

.cheetah-site-settings {
  &__header {
    h1 {
      font-family: 'Muli', sans-serif;
      font-size: 25px;
      font-weight: bold;

      color: #0080FC;
    }
  }


  .card {
    margin-top: 15px;

    &-header {
      font-family: 'Muli', sans-serif;
      font-size: 20px;
      font-weight: bold;
      text-transform: uppercase;

      color: #333333;
      background-color: #F7F7F7;

      box-shadow: 0px 6px 3px #7E7E7E10;
      padding: 24px 32px;
    }

    &-body {
      textarea {
        height: 330px;
        resize: none;
      }
    }
  }
}
</style>

<style scoped>

.labelspacing {
  padding-left: 30px;
  padding-right: 60px;
}

.left {
  left: 30px;
}

@media (min-width: 768px) {
  .page-content-wrapper {
    min-width: 0;
    width: 100%;
  }
}

.page-content-wrapper {
  min-width: 100%;
}

#robots-txt, #ads-txt {
  height: 300px;
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/SiteSettings.vue